'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function DisallowedOccupations(props) {
  return _react2.default.createElement(_radio.RadioYesNo, {
    name: 'disallowedOccupations',
    label: 'Are you a professional or semi-professional sports person or musician?',
    helpText: 'Where your main or only source of income is derived from music or playing a sport.'
  });
}
exports.default = DisallowedOccupations;